export enum StatusCode {
    Success = 0,
    Failed = 1,
    InvalidEmail = 2,
    InvalidRequest = 3,
    NotValidAddress = 4,
    InvalidPhone = 5
  }

export enum LoanPurposeType
{
  CarLoan = 5,
  HomeImprovements = 9,
  DebtConsolidation = 4,
  Others = 3
}

export enum PageType {
  personal,
  address,
  family,
  home,
  result
}
